import { GET_MANY_REFERENCE } from 'react-admin';

const dataBillingTrips = (res, params, type) => {
  const enhancedResource = Object.assign({}, res);
  switch (type) {
    case GET_MANY_REFERENCE:
      res.data.forEach((item, i) => {
        // We insert id to records, because result return from backend doesnt have id
        enhancedResource.data[i].id = i;
        if (!item.trip) {
          enhancedResource.data[i].trip = {
            date: null,
            duration: null,
            length: null,
            tripId: null,
          };
        }
      });
      break;
    default:
      break;
  }
  return enhancedResource;
};

export default dataBillingTrips;
